import { gql } from "@apollo/client";

export const BUYER_REJECT_PROPERTY_MUTATION = gql`
	mutation RejectProperty($params: BuyerParams) {
		buyer(params: $params) {
			rejectProperty
		}
	}
`;
